var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0171 3H21.0706L14.3995 10.6246L22.2475 21H16.1026L11.2897 14.7074L5.7826 21H2.72722L9.8626 12.8446L2.33398 3H8.63491L12.9854 8.75169L18.0171 3ZM16.9454 19.1723H18.6374L7.71552 4.73169H5.89983L16.9454 19.1723Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjAxNzEgM0gyMS4wNzA2TDE0LjM5OTUgMTAuNjI0NkwyMi4yNDc1IDIxSDE2LjEwMjZMMTEuMjg5NyAxNC43MDc0TDUuNzgyNiAyMUgyLjcyNzIyTDkuODYyNiAxMi44NDQ2TDIuMzMzOTggM0g4LjYzNDkxTDEyLjk4NTQgOC43NTE2OUwxOC4wMTcxIDNaTTE2Ljk0NTQgMTkuMTcyM0gxOC42Mzc0TDcuNzE1NTIgNC43MzE2OUg1Ljg5OTgzTDE2Ljk0NTQgMTkuMTcyM1oiIC8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };